<template>
  <div>
    <v-toolbar color="primary">
      <v-toolbar-title class="ml-0 pl-3 white--text" style>
        <strong>
          <span style="font-size:1.2rem;">{{ getSelectedVisa.type }} Application  </span>
        </strong>
      </v-toolbar-title>
    </v-toolbar>

    <v-card class="ma-2 px-5" white>
      <v-card-text>
        <v-layout wrap>
          <v-form class="pt-2" lazy-validation ref="form" row wrap>
            <v-layout row>
              <header-text :text="$vuetify.lang.t('$vuetify.personal_information')"
                           icon="mdi-account"></header-text>
              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.full_name')+' *'"
                    :rules="[rules.required,rules.alpha]"
                    outlined
                    type="text"
                    placeholder="Enter your first, middle, and last name"
                    v-model="visa.traveller.full_name"
                    id="fullName"
                ></v-text-field>
              </v-flex>

              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    label="Nationality *"
                    :rules="[rules.required]"
                    :value="selectedNationality"
                    outlined
                    hint="Non Editable"
                    readonly
                    id="country"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-select
                    :items="genders"
                    :label="$vuetify.lang.t('$vuetify.gender')+' *'"
                    :rules="[rules.required]"
                    outlined
                    v-model="visa.traveller.gender"
                    id="gender"
                ></v-select>
              </v-flex>

              <v-flex md4 xs12 pl-2 pr-6>
                <date-picker-new
                    :label="$vuetify.lang.t('$vuetify.dob')+' *'"
                    v-model="visa.traveller.dob"
                    :min-year="dob.min_year"
                    :max-year="dob.max_year"
                    noneditable="false"
                    :required="true"
                />
              </v-flex>
              <v-flex md4 xs12>
                <v-combobox
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :items="occupationList"
                    item-value="name"
                    item-text="name"
                    :label="$vuetify.lang.t('$vuetify.occupation')+' *'"
                    :rules="[rules.required]"
                    outlined
                    v-model="visa.traveller.occupation"
                    id="occupation"
                ></v-combobox>
              </v-flex>

              <v-flex md4 xs12>

                <address-auto-complete
                    :rules="[rules.required]"
                    :label="$vuetify.lang.t('$vuetify.address')+' of '+currentCountryName+' *'"
                    v-model="visa.traveller.full_address"
                    id="address"
                ></address-auto-complete>
              </v-flex>

              <v-flex md4 sm12 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.contact_no')+ ' of '+currentCountryName+' *'"
                    :prefix="stdCode"
                    :rules="[rules.required]"
                    min="0"
                    outlined
                    type="number"
                    v-model="visa.traveller.contact_number"
                    id="contactNumber"
                ></v-text-field>
              </v-flex>

              <v-flex md4 sm12 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    label="Email *"
                    :rules="[rules.required,rules.email]"
                    outlined
                    type="email"
                    placeholder="Application form will be sent to this email"
                    v-model="visa.traveller.email"
                    id="email"
                ></v-text-field>
              </v-flex>
              <v-flex
                  :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                  md6 md4 xs12>
                <file-input :required="true"
                            placeholder="JPEG, JPG or PNG only"
                            :valid_file_types=imageFileType
                            :label="$vuetify.lang.t('$vuetify.passport_size_image')+ '*'"
                            v-model="visa.traveller.traveller_image"
                            id="userImage"
                            :fileSize="2048"
                ></file-input>
              </v-flex>


              <header-text :text="$vuetify.lang.t('$vuetify.passport_details')"
                           icon="mdi-passport"></header-text>

              <v-flex md4 xs12>
                <v-select
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :items="passportTypesParsed()"
                    :label="$vuetify.lang.t('$vuetify.passport_type')+' *'"
                    :rules="[rules.required]"
                    outlined
                    v-model="visa.passport.passport_type"
                    id="passportType"
                ></v-select>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                    :label="$vuetify.lang.t('$vuetify.passport_number')+' *'"
                    :rules="[rules.required]"
                    outlined
                    readonly
                    hint="Non editable"
                    type="text"
                    v-model="visa.passport.passport_number"
                    id="passportNumber"
                ></v-text-field>
              </v-flex>

              <v-flex md4 xs12 pl-3 pr-2>
                <!--                                <v-text-field-->
                <!--                                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"-->
                <!--                                    :label="$vuetify.lang.t('$vuetify.passport_validity')+' *'"-->
                <!--                                    :rules="[rules.required, rules.passportValidityDate]"-->
                <!--                                    outlined-->
                <!--                                    type="date"-->
                <!--                                    v-model="visa.passport.validity"-->
                <!--                                    id="validity"-->
                <!--                                ></v-text-field>-->
                <date-picker-new
                    :label="$vuetify.lang.t('$vuetify.passport_day')"
                    v-model="visa.passport.validity"
                    :min-year="parseInt(new Date().toISOString().substr(0, 4))"
                    :required="true"
                />
              </v-flex>
              <v-flex md4 xs12
                      :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}">
                <file-input :label="$vuetify.lang.t('$vuetify.passport_image')+ '*'"
                            placeholder="JPEG, JPG, PNG, PDF or DOCX only"
                            :required="true"
                            v-model="visa.passport.passport_image"
                            id="passportImage"
                            :fileSize="2048"
                ></file-input>
              </v-flex>
              <v-flex v-if="type !== 'diplomatic-visa' && type!=='official-visa'" xs12>
                <extra-passport-detail :visa_prop="visa"/>
              </v-flex>
            </v-layout>
          </v-form>
          <v-spacer></v-spacer>
          <v-card-actions style="padding: 0 0;">
            <v-btn
                @click="goBack"
                class="float-right"
                color="red darken-3"
                dark
                large
            >{{ $vuetify.lang.t('$vuetify.back') }}
            </v-btn>
            <v-btn
                @click="proceed"
                class="float-right"
                color="blue darken-3"
                dark
                large
                :loading="conditionLoading"
            >{{ $vuetify.lang.t('$vuetify.proceed') }}
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="showPassportValidityDialog"
        width="500">
      <v-card>
        <v-card-title class="headline white lighten-2">
          Alert !
        </v-card-title>

        <v-card-text>
          <span
              style="color: black; font-size:14px; ">You {{ visa.passport.passport_type === 'Travel Document' ? visa.passport.passport_type : 'Passport' }} is going to expire in less than 6 months. Are you sure to proceed ?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="showPassportValidityDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="proceedToNext"
          >
            Proceed Anyway
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddressAutoComplete from "../../components/AddressAutoComplete";
import {validationMixin} from "../../mixins/validationMixin";
import FileInput from "../../components/FileInput";
import {passportTypes} from "../../constant/appConstant";
import HeaderText from "../../components/HeaderText";
import DatePickerNew from "../../components/DatePickerNew";
import ExtraPassportDetail from "../../components/visa/ExtraPassportDetail";


export default {
  data: () => ({
    dialog: false,
    imageFileType: ["png", "jpeg", "jpg"],
    passportSizeImage: {file: null, valid: true},
    genders: ["Male", "Female", "Others"],
    zoom: 1,
    passportList: [],
    conditionLoading: false,
    showPassportValidityDialog: false
  }),
  props: {
    type: String
  },
  mixins: [validationMixin],
  components: {
    ExtraPassportDetail,
    "address-auto-complete": AddressAutoComplete,
    HeaderText, FileInput, DatePickerNew
  },
  methods: {
    ...mapActions({
      checkDocumentInformationValidation: 'VisaSingle/checkDocumentInformationValidation',
      fetchConditionByVisaTypeSlug: 'VisaType/fetchConditionByVisaTypeSlug',
      fetchVisaTypeCondition: 'VisaType/fetchCondition'
    }),
    passportTypesParsed() {
      if (this.type == "diplomatic-visa") {
        return ["Diplomatic"];
      } else if (this.type == "official-visa") {
        return ["Diplomatic", "Official/Service", "Laissez-passer"];
      } else {
        return this.passportTypes;
      }
    },

    async proceed() {
      if (this.$refs.form.validate()) {
        let monthDifferenceCheck = this.isPassportValidityMoreThan6Months()
        if (monthDifferenceCheck === 2) {
          await this.proceedToNext();
        } else if (monthDifferenceCheck === 1) {
          this.showPassportValidityDialog = true
        }
      } else {
        this.$store.commit('Notification/showError', 'Invalid form data')
      }
    },
    isPassportValidityMoreThan6Months() {
      let date1 = Date.parse(this.visa.passport.validity);
      let date2 = Date.now();
      if (date1 < date2) {
        this.$store.commit('Notification/showError', 'Invalid document expiry date. Expiry date cannot be past dates')
        return 0;
      } else if (this.monthDiff(date2, date1) < 6) {
        return 1;
      }
      return 2;
    },

    monthDiff(d1, d2) {
      let date1 = new Date(d1)
      let date2 = new Date(d2)
      let months;
      months = (date2.getFullYear() - date1.getFullYear()) * 12;
      months -= date1.getMonth();
      months += date2.getMonth();
      console.log(months)
      return months <= 0 ? 0 : months;
    },
    goBack() {
      this.$router.push({
        name: "HomePage"
      });
    },
    async proceedToNext() {
      this.conditionLoading = true;
      let conditions = await this.fetchVisaTypeCondition();
      // if (conditions.remaining_days === 0) {
      //     this.conditionLoading = false;
      //     this.$store.commit('Notification/showError', "Cannot proceed you don't have remaining days in current year")
      // } else {
      this.conditionLoading = false;
      this.$router.push({
        name: 'SelectArrivalVisa',
        params: {
          office: this.office,
          apply: this.apply_type
        }
      })
    // }
  },


  addressChanged(e) {
    this.visa.extra.address.full_address = e;
  }
}
,
beforeRouteEnter(to, from, next)
{

  if (!from.name) {
    next(vm => {

      let apply_type = vm.$route.params.apply;
      let office = vm.$route.params.office;
      if (apply_type === 'arrival') {
        vm.$router.push({
          name: 'OnArrival',
          params: {office}
        })
      } else {
        vm.$router.push({
          name: 'OnlineApplication'
        })
      }

    })
  }
  next();
}
,
mounted()
{
  this.$store.commit('DynamicValues/setKey', 'occupations')
  this.$store.dispatch('DynamicValues/fetchDynamicValues');
  this.$store.commit('VisaSingle/setApplyType', this.$route.params.apply);
  this.$store.commit('VisaSingle/setOffice', this.$route.params.office)

  this.visa.traveller.country = this.currentNationality;
  this.passportList = passportTypes;
  this.visa.passport.passport_type = this.countryCode !== "" ? this.visa.passport.passport_type : this.passportTypes[3];
}
,
computed:{
    ...mapGetters("Notification", ["snackbar"]),
    ...mapGetters('VisaSingle', ['price', 'visaCatOptions', 'occupationOptions', 'apply_type', 'office']),

  countryCode()
  {
    return this.$store.state.CountryForTouristList.current.code;
  }
,
  getSelectedVisa()
  {
    return this.$store.state.VisaType.visa_type;
  }
,
  visas()
  {
    return this.$store.state.VisaTypeList.all;
  }
,
  currentCountryName()
  {
    return this.$store.state.CountryForTouristList.current.country_name;
  }
,
  selectedNationality()
  {
    return this.$store.state.CountryForTouristList.current.nationality;
  }
,
  stdCode()
  {
    return this.$store.state.CountryForTouristList.current.std_code;
  }
,
  currentNationality()
  {
    return this.$store.state.CountryForTouristList.current.id;
  }
,
  visa()
  {
    let v = this.$store.state.VisaSingle.visa;
    if (typeof this.currentNationality === "undefined") {
      // if (this.apply_type) {
      //     if (this.apply_type === 'arrival') {
      //         this.$router.push({
      //             name: 'OnArrival',
      //             params: {
      //                 type: this.office
      //             }
      //         })
      //     } else {
      //         this.$router.push({
      //             name: 'OnlineApplication'
      //         })
      //     }
      // }
    } else {
      v.traveller.country = this.currentNationality;
    }
    return v;
  }
,
  defaultLanguage()
  {
    return require("@/assets/flags/" + this.$vuetify.lang.current + ".png");
  }
,
  passportTypes()
  {
    let pptype = JSON.parse(JSON.stringify(this.passportList));
    if (this.getSelectedVisa.slug !== 'tourist-visa') {
      pptype.pop();
      pptype.shift();
    }
    return pptype;
  }
,
  occupationList()
  {
    return this.$store.state.DynamicValues.occupations;
  }
,
  dob()
  {
    const max_year = parseInt(new Date().toISOString().substr(0, 4));
    const min_year = parseInt(max_year) - 120;
    return {
      min_year,
      max_year
    }
  }
,
}
}

</script>
